import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { SellsReportsPackages } from 'src/app/models/sells-reports-packages';
import { NgbInputDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reportfinance',
  templateUrl: './reportfinance.component.html',
  styleUrls: ['./reportfinance.component.scss']
})
export class ReportfinanceComponent implements OnInit {
  breadcrumbs: {name: string, path?: string, link: boolean}[] = [];
  office: string | null = '';
  month: string | null = null;
  year: string | null = null;
  dataPackages: SellsReportsPackages[] = [];
  dataPackagesFilter: SellsReportsPackages[] = [];
  startDate!: NgbDateStruct;
  endDate!: NgbDateStruct;

  constructor(private api: ApiService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.office = this.route.snapshot.paramMap.get('officeId');
    this.month = this.route.snapshot.paramMap.get('month');
    this.year = this.route.snapshot.paramMap.get('year');

    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Reporte de Finanzas',
        path: '/finance/list',
        link: true,
      },
      {
        name: 'Ventas del Mes de ' + this.month,
        link: false
      }
    ];

    this.getSellData();
  }

  getSellData(): void {
    const parameters = `${this.office}/${this.month}/${this.year}`;
    this.api.getById('finance', parameters).subscribe({
      next: data => {
        this.dataPackages = data.data;
        this.dataPackagesFilter = this.dataPackages;
      },
      error: err => {}
    });
  }

  onOpenToggle(d: NgbInputDatepicker): void {
    const year = parseInt(this.year as string);
    const month = this.numberMonth(this.month as string);

    d.open();

    setTimeout(() => {
      d.navigateTo({ year, month });
    }, 0);
  }

  onFilterData(): void {
    let endDate: Date;
    const startDate = new Date(`${this.startDate.year}/${this.startDate.month}/${this.startDate.day}`);
    
    if (!this.endDate) {
      const { year, month } = this.startDate;
      endDate = new Date(year, month, 0);
    } else {
      endDate = new Date(`${this.endDate.year}/${this.endDate.month}/${this.endDate.day}`);
    }

    this.dataPackagesFilter = this.dataPackages.filter((item: SellsReportsPackages) => {
      const itemDate = new Date(item.createdAt.replace(/-/g, "/"));
      itemDate.toLocaleDateString('es-MX');

      return itemDate >= startDate && itemDate <= endDate;
    });
  }

  onResetFields(): void {
    this.startDate = {} as NgbDateStruct;
    this.endDate = {} as NgbDateStruct;

    this.dataPackagesFilter = this.dataPackages;
  }

  private numberMonth(month: string): number {
    let monthNumber: number;

    switch (month) {
      case 'Enero':
        monthNumber = 1;
        break;
      case 'Febrero':
        monthNumber = 2;
        break;
      case 'Marzo':
        monthNumber = 3;
        break;
      case 'Abril':
        monthNumber = 4;
        break;
      case 'Mayo':
        monthNumber = 5;
        break;
      case 'Junio':
        monthNumber = 6;
        break;
      case 'Julio':
        monthNumber = 7;
        break;
      case 'Agosto':
        monthNumber = 8;
        break;
      case 'Septiembre':
        monthNumber = 9;
        break;
      case 'Octubre':
        monthNumber = 10;
        break;
      case 'Noviembre':
        monthNumber = 11;
        break;
      case 'Diciembre':
        monthNumber = 12;
        break;
      default:
       monthNumber = 1;
       break;
    }

    return monthNumber;
  }
}
